import classNames from 'classnames';
import _ from 'lodash-es';
import React from 'react';
import { Table } from 'reactstrap';
import locals from './index.scss';
export const Report = ({ record }) => (React.createElement(Table, { hover: true, borderless: true, size: 'sm', className: locals.table },
    React.createElement("thead", null,
        React.createElement("tr", null,
            React.createElement("th", { className: classNames('text-right', locals.name) }, "#"),
            React.createElement("th", { className: locals.value }, "Value"),
            React.createElement("th", null))),
    React.createElement("tbody", null, _.map(record, ([name, value, button], index) => (React.createElement("tr", { key: index },
        React.createElement("td", { className: classNames('text-monospace', 'text-right') }, name),
        React.createElement("td", null, value),
        React.createElement("td", null, button)))))));
